export default __webpack_public_path__ + "static/flyer-buderus-60dc8481446be3c013c36e0f84351432.jpg";